import { Categories } from './categoriesResource';
import errorTransformer from '@/api/shared/transformers/errorTransformer';

function getCategories() {
  return Categories.get()
    .then(({ body: { categories = [] } = {} }) => categories)
    .catch(errorTransformer);
}

function getPublishRules({ categoryId }) {
  return Categories.getPublishRules({ categoryId })
    .then(({ body: { data } }) => data)
    .catch(errorTransformer);
}

export default {
  getCategories,
  getPublishRules,
};
